import log from "./log.js";
import util from "./util.js";
import config from "../config.js";

const { info, warn, error } = log;
const { isMission } = util;

export default class NativeLoad {
  constructor() {
    // this.onLoad = this.onEvent("load-success");
    // this.emitLoad = this.emitEvent("load-success");
    // this.onLoadFail = this.onEvent("load-fail");
    // this.emitLoadFail = this.emitEvent("load-fail");
  }

  // 最大尝试加载次数
  static get loadNumberMax() {
    return 3;
  }

  // 尝试加载次数
  get loadNumber() {
    return this._loadNumber || 0;
  }

  set loadNumber(number) {
    this._loadNumber = number || 0;
  }

  /**
   * 加载状态
   * -1 - 加载失败
   * 0 - 加载中
   * 1 - 加载成功
   */
  get loadState() {
    return this._loadState || 0;
  }

  set loadState(state) {
    if ([-1, 0, 1].includes(state)) this._loadState = state;
    else error(2002, "native loadState set value illegal");
  }

  checkCordova() {
    return (
      window.cordova &&
      window.cordova.version &&
      window.cordova instanceof Object
    );
  }

  checkHasLoadedCordova() {
    return (
      window[config.cordovaImportLockName] ||
      window.hasOwnProperty(config.cordovaImportLockName)
    );
  }

  // 项目中含有自己引入的cordova，如index.html里面已经含有引入cordova的script标签
  hasSelfCordova() {
    const scriptTags = document.getElementsByTagName("script");
    let re = false;
    for (let i = 0; i < scriptTags.length; i++) {
      if (/.*(cordova.js|cordova_plugins.js).*/.test(scriptTags[i].src)) {
        re = true;
        break;
      }
    }
    return re;
  }

  loadCordova(isTemp = false) {
    if (this.checkHasLoadedCordova()) {
      return Promise.reject();
    }

    // 锁定逻辑，避免多插件重复引入cordova
    window[config.cordovaImportLockName] = true;

    return new Promise((resolve, reject) => {
      if ((this.hasSelfCordova() && !isTemp) || this.checkCordova() || !isMission()) {
        let self = this;
        window.document.addEventListener(
          "deviceready",
          function () {
            self.loadCordovaSuccess(resolve);
          },
          false
        );
        return;
      }
      // 超过尝试加载次数则加载失败
      if (this.loadNumber < NativeLoad.loadNumberMax) {
        this.loadNumber++;
        this.cordovaLoad(isTemp)
          .then(() => this.loadCordovaSuccess(resolve))
          .catch(() => this.loadCordovaError());
      } else this.loadCordovaFail(reject);
    });
  }

  loadCordovaSuccess(resolve) {
    info("Cordova load success!");
    this.loadState = 1;
    window[config.cordovaReady] = "1";
    // this.emitLoad();
    resolve();
  }

  loadCordovaError(err) {
    error(2002, "Cordova load error! number:", this.loadNumber);
    error(2002, err);
    this.loadState = 0;
    this.loadCordova();
  }

  loadCordovaFail(reject) {
    error(2002, "Cordova load fail!");
    this.loadState = -1;
    // this.emitLoadFail();
    reject();
  }

  loadCordovajs(jsPath, resolve, reject) {
    try {
      const script = window.document.createElement("script");
      script.src = jsPath;
      script.type = "text/javascript";
      script.async = true;
      window.onerror = (e, url) => {
        reject([e, url]);
      };
      script.onload = (e) => {
        window.document.addEventListener("deviceready", resolve, false);
      };
      script.onerror = (err) => {
        reject(err);
      };
      window.document.head.appendChild(script);
    } catch (e) {
      reject(e);
    }
  }

  cordovaLoad(isTemp) {
    return new Promise((resolve, reject) => {
      try {
        // 加载临时cordova.js不成功，则加载真正的cordova.js
        if (isTemp) {
          this.loadCordovajs(config.cordovaTempPath, resolve, (e) => {
            if (
              Array.isArray(e) &&
              e.length === 2 &&
              e[1].includes(config.cordovaTempPath.replace(".", ""))
            ) {
              this.loadCordovajs(config.cordovaPath, resolve, reject);
            }
          });
        } else {
          this.loadCordovajs(config.cordovaPath, resolve, reject);
        }
      } catch (er) {
        console.log("cordovaLoad error");
        reject(er);
      }
    });
  }

  get eventQueue() {
    if (!this._eventQueue) this._eventQueue = new Map();
    return this._eventQueue;
  }

  onEvent(name) {
    return function (func) {
      const self = this;
      if (typeof func !== "function") {
        warn(`native onEvent ${name} 参数不正确`);
        return;
      }
      let queue = self.eventQueue.get(name);
      if (!queue) {
        queue = new Set();
        self.eventQueue.set(name, queue);
      }
      if (queue.has(func)) return;
      queue.add(func);
    }.bind(this);
  }

  emitEvent(name, clear = true) {
    return function () {
      const self = this;
      const queue = self.eventQueue.get(name);
      queue && queue.size && queue.forEach((func) => setTimeout(func));
      // clear queue
      if (clear) {
        queue && queue.clear();
        self.eventQueue.delete(name);
      }
    }.bind(this);
  }
}
